import React, { useEffect, useState } from "react";
import {
  FaBookOpen,
  FaFileAlt,
  FaEye,
  FaDownload,
  FaLayerGroup,
} from "react-icons/fa";
import studentAxios from "../constants/studentAxios";

const CourseMaterial = () => {
  const studentId = localStorage.getItem("studentId");
  const sessionId = localStorage.getItem("currentSessionId");

  const [student, setStudent] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH STUDENT ---------------- */
  useEffect(() => {
    if (!studentId) return;
    const fetchStudent = async () => {
      try {
        const res = await studentAxios.get(
          `/students/getStudents/${studentId}`,
          { params: { sessionId } }
        );
        setStudent(res.data);
      } catch (err) {
        console.error("Error fetching student:", err);
      }
    };
    fetchStudent();
  }, [studentId]);

  /* ---------------- FETCH MATERIAL ---------------- */
  useEffect(() => {
    if (!student || !sessionId) return;

    const fetchMaterials = async () => {
      try {
        const res = await studentAxios.get(
          `/coursematerial/getCourseMaterialByClassAndSection/${encodeURIComponent(
            student.class
          )}/${encodeURIComponent(student.section)}`,
          { params: { sessionId } }
        );
        setMaterials(res.data);
      } catch (err) {
        console.error("Error fetching materials:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMaterials();
  }, [student, sessionId]);

  /* ---------------- LOADING ---------------- */
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen text-lg font-semibold">
        Loading…
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4 md:p-6">
      {/* ---------------- EMPTY STATE ---------------- */}
      {materials.length === 0 ? (
        <div className="flex flex-col justify-center items-center bg-white shadow-md rounded-lg p-8 mt-10">
          <FaBookOpen className="text-gray-400 text-6xl mb-4 animate-bounce" />
          <p className="text-gray-600 text-lg">
            No course materials available.
          </p>
        </div>
      ) : (
        /* ---------------- GRID ---------------- */
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {materials.map((m) => (
            <div
              key={m._id}
              className="p-5 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-1 hover:scale-[1.02]"
            >
              {/* HEADER */}
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-semibold text-gray-800 flex items-center">
                  <FaFileAlt className="text-indigo-500 mr-2" />
                  {m.title}
                </h3>

                <span className="bg-indigo-100 text-indigo-700 text-xs font-semibold px-2 py-1 rounded-full">
                  {m.subjectName}
                </span>
              </div>

              {/* META */}
              <p className="text-gray-600 mb-1 flex items-center text-sm">
                <FaLayerGroup className="mr-2 text-gray-400" />
                Class {student.class} – Section {student.section}
              </p>

              <p className="text-gray-700 text-sm mb-3">
                {m.description || "No description provided"}
              </p>

              {/* ACTIONS */}
              <div className="flex justify-between items-center mt-4 text-sm">
                <a
                  href={m.courseMaterialFile}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline flex items-center gap-1"
                >
                  <FaEye /> View
                </a>

                <a
                  href={`${process.env.REACT_APP_API_BASE_URL}/api/coursematerial/download/${m._id}?sessionId=${sessionId}`}
                  download
                  className="text-green-600 hover:underline flex items-center gap-1"
                >
                  <FaDownload /> Download
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CourseMaterial;
